import { render, staticRenderFns } from "./CreateSaleInvoice.vue?vue&type=template&id=513bdea7"
import script from "./CreateSaleInvoice.vue?vue&type=script&lang=js"
export * from "./CreateSaleInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports